import React, { Component } from 'react'
import FormularioSecuenciaIntentoGrid from './FormularioSecuenciaIntentoGrid.jsx'
import {FormattedMessage, injectIntl} from 'react-intl';

class FormularioSecuenciaIntento extends Component {
	render() {
	    return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
      					<h3 className="content-header-title"><FormattedMessage id="formularioSecuenciaIntento.label_seguimiento_ingresos" defaultMessage="Seguimiento de secuencias"/></h3>
      				</div>
				</div>
				<div className="content-body">
					<FormularioSecuenciaIntentoGrid />
				</div>
			</div>
	    );
  	}
}

export default injectIntl(FormularioSecuenciaIntento);
